import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
// Utility function to clean up model names by removing provider prefixes
const cleanModelName = (modelName) => {
    // Remove common provider prefixes
    const prefixesToRemove = ['deepinfra-', 'openai-', 'anthropic-', 'google-', 'meta-'];
    for (const prefix of prefixesToRemove) {
        if (modelName.toLowerCase().startsWith(prefix)) {
            return modelName.substring(prefix.length);
        }
    }
    return modelName;
};
export const SynthesisDisplay = ({ synthesis, onCopy, className = "" }) => {
    const [copied, setCopied] = useState(false);
    const handleCopy = async () => {
        if (onCopy) {
            onCopy(synthesis.content);
        }
        else {
            try {
                await navigator.clipboard.writeText(synthesis.content);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            }
            catch (err) {
                console.error('Failed to copy synthesis:', err);
            }
        }
    };
    const getConfidenceColor = (confidence) => {
        if (confidence >= 0.8)
            return 'text-green-600 bg-green-50 border-green-200';
        if (confidence >= 0.6)
            return 'text-yellow-600 bg-yellow-50 border-yellow-200';
        return 'text-orange-600 bg-orange-50 border-orange-200';
    };
    const getConfidenceLabel = (confidence) => {
        if (confidence >= 0.8)
            return 'High Confidence';
        if (confidence >= 0.6)
            return 'Medium Confidence';
        return 'Lower Confidence';
    };
    return (_jsxs("div", { className: `bg-white border border-gray-200 rounded-lg shadow-sm ${className}`, children: [_jsx("div", { className: "p-4 border-b border-gray-100", children: _jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { className: "flex items-center space-x-3", children: [_jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("span", { className: "text-2xl", children: "\uD83D\uDD2C" }), _jsxs("div", { children: [_jsx("h3", { className: "text-lg font-semibold text-purple-700", children: "Multiwise Intelligence Synthesis" }), _jsx("p", { className: "text-xs text-gray-500", children: "AI-powered combination of multiple model perspectives" })] })] }), synthesis.confidence && (_jsx("div", { className: `px-2 py-1 rounded text-xs font-medium border ${getConfidenceColor(synthesis.confidence)}`, children: getConfidenceLabel(synthesis.confidence) }))] }), _jsxs("button", { onClick: handleCopy, className: "flex items-center space-x-2 px-3 py-1.5 text-sm bg-purple-50 text-purple-700 rounded hover:bg-purple-100 transition-colors", children: [_jsx("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" }) }), _jsx("span", { children: copied ? 'Copied!' : 'Copy Synthesis' })] })] }) }), _jsx("div", { className: "p-4", children: _jsx("div", { className: "prose prose-sm max-w-none", children: _jsx("div", { className: "whitespace-pre-wrap text-gray-700 leading-relaxed", children: synthesis.content }) }) })] }));
};
